export default function PackageType({boxShape}) {
  return (
    <li className="list__item--order-data list__item--shipping-info">
      <strong className="margin-right-3">Package Type:</strong>
      {boxShape ? <span>{boxShape}</span> : <em>None selected</em>}
    </li>
  )
}
